import axiosClientNet from "./axiosClientNet";
import {IEpgItem} from "../interfaces/IEpgItem";
import {IChannel} from "../interfaces/IChannel";
import {IChannelDetails} from "../interfaces/IChannelDetails.ts";
import {IUserBasic} from "../interfaces/IUserBasic.ts";
import {IUpdateUserRoleRequest} from "../request/updateUserRolesRequest.ts";
import {IContactFormSendMessageRequest} from "../request/contactFormSendMessageRequest.ts";
import {IPromotionBanner} from "../interfaces/templates/bannerHome/IPromotionBanner.ts";
import {IPopularChannel} from "../interfaces/IPopularChannel.ts";
import {ISearchEpg} from "../interfaces/ISearchEpg.ts";
import {IAuthenticatedResponse} from "../response/authenticatedResponse.ts";
import {IFavorite} from "../interfaces/account/favorite/IFavorite.ts";
import {IGetMeResponse} from "../response/account/getMeResponse.ts";
import {AccountRecordingResponse} from "../response/account/accountRecordingResponse.ts";
import {AddFavoriteRequest} from "../request/account/addFavoriteRequest.ts";

const api = {
    // account
    accountChangePassword: (actualPassword: string, newPassword: string, confirmPassword: string, logoutFromAllDevices: boolean) => {
        return axiosClientNet.post('/account/change-password', {
            actualPassword,
            newPassword,
            confirmPassword,
            logoutFromAllDevices
        });
    },
    addFavorite: (newFavorite: AddFavoriteRequest) => {
        return axiosClientNet.post('/account/favorite', newFavorite)
    },
    getFavorites: () => {
        return {
            data:
                [
                    {
                        "id": "89d2f39e-8b70-4820-a879-ea8a44580d07",
                        "name": "kiepsk",
                        "searchQuery": "kiepsk",
                        "type": "program",
                        "position": 1
                    },
                    {
                        "id":
                            "31f680bc-6ef1-4e2d-b0aa-abe094320564",
                        "name":
                            "kiepski",
                        "searchQuery":
                            "kiepski",
                        "type":
                            "search",
                        "position":
                            2
                    }
                    ,
                    {
                        "id":
                            "6a11c486-1f71-467b-8567-88d0d29370c9",
                        "name":
                            "kieps",
                        "searchQuery":
                            "kieps",
                        "type":
                            "search",
                        "position":
                            3
                    }
                ]
        };
        return axiosClientNet.get<IFavorite[]>(`/account/favorites`);
    },
    deleteFavorite: (id: string) => {
        return axiosClientNet.delete(`/account/favorites/${id}`);
    },
    // account admin
    getRolesWithUsers: () => {
        return axiosClientNet.get(`/account/roles/manage/users`);
    },
    getUserWithRoles: (userId: string) => {
        return axiosClientNet.get(`/account/roles/manage/users/${userId}`);
    },
    getSearchedUsersWithRoles: (searchPhrase: string) => {
        return axiosClientNet.get<IUserBasic[]>('/account/roles/manage/search', {params: {query: searchPhrase}});
    },
    updateUserRoles: (userId: string, request: IUpdateUserRoleRequest) => {
        return axiosClientNet.post(`/account/roles/manage/users/${userId}`, request);
    },
    deleteUser: (customerId: string) => {
        return axiosClientNet.delete(`/admin/users/${customerId}`);
    },
    /////////////
    // account recording
    createRecording: (epgId: number) => {
        return axiosClientNet.post("/account/recordings", {epgId});
    },
    getRecordings: () => {
        return axiosClientNet.get<AccountRecordingResponse>("/account/recordings");
    },
    deleteRecording: (id: number) => {
        return axiosClientNet.delete(`/account/recordings/${id}`);
    },
    testcookie: () => {
        return axiosClientNet.post('/api/test-session');
    },
    /////////////
    // marketing
    addPromotionBanner: (request: FormData) => {
        return axiosClientNet.post('/marketing/promotion-banners', request, {headers: {'Content-Type': 'multipart/form-data'}});
    },
    getPromotionBanner: (id: string) => {
        return axiosClientNet.get(`/marketing/promotion-banners/${id}`);
    },
    getPromotionBannersAll: () => {
        return axiosClientNet.get<{ id: string, title: string }[]>('/marketing/promotion-banners');
    },
    updatePromotionBanner: (request: FormData, bannerId: string) => {
        if (import.meta.env.VITE_BACKEND_TYPE === 'php')
            return axiosClientNet.post(`/marketing/promotion-banners/${bannerId}`, request, {headers: {'Content-Type': 'multipart/form-data'}});
        return axiosClientNet.put(`/marketing/promotion-banners/${bannerId}`, request, {headers: {'Content-Type': 'multipart/form-data'}});
    },
    deletePromotionBanner: (id: string) => {
        return axiosClientNet.delete(`/marketing/promotion-banners/${id}`);
    },
    ////
    // view-models
    getHomeVM: () => {
        return axiosClientNet.get<{ banner: IPromotionBanner, popularChannels: IPopularChannel[] }>('/home/home-vm');
    },
    /////////////
    getCsrfCookie: () => {
        return axiosClientNet.get('/sanctum/csrf-cookie');
    },
    getAuthCreate: () => {
        return axiosClientNet.get('/user');
    },
    pingVideoSession: () => {
        return axiosClientNet.get('/video-sessions/ping');
    },
    logoutFromAllDevices: () => {
        return axiosClientNet.delete('/auth/logout/all');
    },
    login: (reCaptchaToken: string, email: string, password: string, rememberMe: boolean, osInfo: string) => {
        return axiosClientNet.post<IAuthenticatedResponse>('/auth/login', {
            reCaptchaToken,
            email,
            password,
            rememberMe,
            osInfo
        });
    },
    loginPHP: (reCaptchaToken: string, id: number, password: string, rememberMe: boolean, osInfo: string, fcmToken: string) => {
        return axiosClientNet.post<IAuthenticatedResponse>('/auth/login', {
            reCaptchaToken,
            id,
            password,
            rememberMe,
            osInfo,
            fcmToken
        });
    },
    resetPassword: (token: string, password: string, confirmPassword: string) => {
        return axiosClientNet.post('/auth/change-password', {token, password, confirmPassword});
    },
    confirmRegistration: (token: string) => {
        return axiosClientNet.get(`/auth/confirm-registration/${token}`);
    },
    recoverPassword: (recaptchaToken: string, email: string) => {
        return axiosClientNet.post('/auth/recover-password', {recaptchaToken, email});
    },
    refreshToken: (rememberMe: boolean) => {
        return axiosClientNet.post<IAuthenticatedResponse>('/auth/refresh-token', {rememberMe});
    },
    logout: () => {
        return axiosClientNet.delete('/auth/logout');
    },
    register: (email: string, password: string, confirmPassword: string, token: string) => {
        return axiosClientNet.post('/auth/register', {email, password, confirmPassword, token});
    },
    contactFormSendMessage: (request: IContactFormSendMessageRequest) => {
        return axiosClientNet.post('/contact/contact-form', request);
    },
    verifyChangePasswordToken: (token: string) => {
        return axiosClientNet.get(`/auth/change-password/${token}`);
    },
    verifyRegisterToken: (token: string) => {
        return axiosClientNet.get(`/auth/register/${token}`);
    },
    getChannel: (channelId: number, since: Date) => {
        return axiosClientNet.get<IChannelDetails>(`/channel/${channelId}`, {params: {since: since.toDateString()}});
    },
    getChannelList: () => {
        console.log("hshshshshs");
        return axiosClientNet.get<IChannel[]>('/channel/getall');
    },
    getRnDChannelList: () => {
        return axiosClientNet.get<IChannel[]>('/rnd/channels');
    },
    VmForPlayer: () => {
        return axiosClientNet.get<IChannel[]>('/channel/vm-for-player');
    },
    getInitialEpgPage: (fromUnixTimestamp: number, hours: number) => {
        return axiosClientNet.get('/channel/get-initial-epg-page', {params: {fromUnixTimestamp, hours}});
    },
    getChannelsWithEpgItems: (fromUnixTimestamp: number, toUnixTimestamp: number) => {
        return axiosClientNet.get('/channel/getAllWithEpgItems', {params: {fromUnixTimestamp, toUnixTimestamp}});
    },
    getMe: () => {
        return axiosClientNet.get<IGetMeResponse>('/account');
    },
    // getMe: (jwtToken: string) => {
    //     return axiosClientNet.get('/account', {headers: {Authorization: `Bearer ${jwtToken}`}})
    // },
    getNextEpgItems: (ch_id: number, fromTimestamp: number, limit: number) => {
        return axiosClientNet.get<IEpgItem[]>('/epgs/next-items', {
            params: {
                channelId: ch_id,
                from: fromTimestamp,
                limit: limit
            }
        })
    },
    getPreviousEpgItems: (ch_id: number, toTimestamp: number, limit: number) => {
        return axiosClientNet.get<IEpgItem[]>('/epgs/previous-items', {
            params: {
                channelId: ch_id,
                from: toTimestamp,
                limit: limit
            }
        })
    },
    getNextEpisodesComing: (epgId: number) => {
        if (import.meta.env.VITE_BACKEND_TYPE === 'php') {
            return axiosClientNet.get(`epgs/${epgId}/next-episodes`);
        } else {
            return axiosClientNet.get('/epgs/next-episode-coming', {params: {epgId}});
        }
    },
    getToken: (channelId: number) => {
        return axiosClientNet.get<string>('/stalker/token', {params: {channelId}, withXSRFToken: false});
    },
    getEpg: (id: number) => {
        return axiosClientNet.get<IEpgItem>(`/epgs/${id}`);
    },
    getEpgsSegment: (fromTimestamp: number) => {
        return axiosClientNet.get<{
            fromTimestamp: number,
            toTimestamp: number,
            data: IEpgItem[]
        }>('/epgs/segment', {params: {fromTimestamp}});
    },
    getPopularChannels: () => {
        return axiosClientNet.get('/channel/popular-channels');
    },
    getEpgSearchResults: (query: string) => {
        return axiosClientNet.get<ISearchEpg[]>('/search', {params: {query}});
    }
}
export default api;